import ImageCard from './imageCard';

export default ImageCard;
